import { useQuery } from "@tanstack/react-query";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { FullSizeLoader } from "@/design-system/FullSizeLoader";
import { documentMutations } from "@/queries/documents/mutations";
import { useDocumentQueries } from "@/queries/documents/queryOptions";

import { DocumentRootList } from "./DocumentRootList";

export function DocumentRootListPage(): React.ReactNode {
  const documentQueries = useDocumentQueries();
  const { data = [], isLoading, error } = useQuery(documentQueries.listRoots());
  const { mutateAsync: deleteRootFolder } = documentMutations.useDeleteRootFolder();

  if (error) {
    return <ErrorPage error={error} />;
  }

  if (isLoading) {
    return <FullSizeLoader withPadding />;
  }

  return <DocumentRootList rootList={data} onDeleteFolder={deleteRootFolder} />;
}
